import React, { PropsWithChildren } from "react";
import { useBookingsContext } from "../../Context/BookingsContext";
import { useTimeZoneContext } from "../../../../lib/context/TimeZone/TimeZoneContext";
import { MainResources } from "../../../../lib/types/main.types";
import { Button } from "../../../shared/Button/Button";
import { Icon } from "../../../shared/Icon/Icon";
import { Tooltip } from "../../../shared/Tooltip/Tooltip";
import { forReservationDate } from "../../lib/datePickerHelper";

import "./BookingsSearchHeader.scss";

export const BookingsSearchHeader = ({
  type,
}: PropsWithChildren<{
  type: MainResources;
}>) => {
  const {
    headerInfo: { day, location, time },
    dates,
  } = useBookingsContext();
  const { timeZone } = useTimeZoneContext();

  const additionalDatesCount = dates.length > 1 ? dates.length - 1 : 0;

  const allSelectedDates = additionalDatesCount
    ? [...dates]
        .sort((a, b) => a.getTime() - b.getTime())
        .map((selectedDate) => forReservationDate(selectedDate, timeZone))
        .join(" | ")
    : "";

  return (
    <div className="BookingsSearchHeader flex-a-center flex-wrap justify-content-between mb-3">
      <div className="flex-a-center BookingsSearchHeader__header">
        <div className="flex-a-center">
          <Icon icon="bookings-search" />
          <h1>Results matching {type}s</h1>
        </div>

        <Button
          title="Back to top"
          icon="arrow-up-simple"
          color="outline-primary"
          size="small"
          className="BookingsSearchHeader__back"
          onClick={() => {
            return window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        />
      </div>

      <div className="flex-a-center BookingsSearchHeader__subHead">
        <Icon icon="search-right-arrow" />

        <div className="BookingsSearchHeader__inputs">
          <div className="flex-a-center">
            <Icon icon="calendar-simple" />
            <span>{day}</span>
            {!!additionalDatesCount && (
              <Tooltip content={allSelectedDates} position="bottom">
                <span className="BookingsSearchHeader__daysBadge">
                  +{additionalDatesCount}
                </span>
              </Tooltip>
            )}
          </div>

          <div className="flex-a-center">
            <Icon icon="clock-icon" />
            <span>{time}</span>
          </div>

          <div className="flex-a-center BookingsSearchHeader__inputs--location">
            <Icon icon="location-reserve" />
            <span>{location}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
